<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  dates: { type: Array, default: () => [] },
  activeIndex: { type: Number, default: 0 },
});

const emit = defineEmits(['select']);

const toDate = value => (value instanceof Date ? value : new Date(value));

const tabWeekday = value => {
  const date = toDate(value);
  const weekday = date.toLocaleDateString('pt-BR', { weekday: 'short' });
  return weekday.charAt(0).toUpperCase() + weekday.slice(1);
};

const tabDate = value =>
  new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
  }).format(toDate(value));
</script>

<template>
  <nav class="border-b border-lais-border bg-white px-1">
    <div
      class="mx-auto flex max-w-[720px] justify-start overflow-x-auto no-scrollbar py-2 sm:justify-center"
    >
      <button
        v-for="(date, index) in dates"
        :key="date"
        type="button"
        class="relative inline-flex h-10 shrink-0 items-center gap-1 px-3 text-[14px] font-semibold transition-colors"
        :class="
          activeIndex === index
            ? 'text-lais-primary'
            : 'text-lais-text-body hover:text-lais-primary'
        "
        :aria-pressed="activeIndex === index"
        @click="emit('select', index)"
      >
        <span>{{ tabWeekday(date) }}</span>
        <span>{{ tabDate(date) }}</span>
        <span
          v-if="activeIndex === index"
          class="absolute bottom-[-9px] left-2 right-2 h-[3px] rounded-t bg-lais-primary"
          aria-hidden="true"
        />
      </button>
    </div>
  </nav>
</template>
